import {Page} from 'router/page';
import {loadable} from 'router/routes';
import CMSUtils from 'utils/cms';

import {initialState as searchRequestInitialState} from 'search-request/search-request-reducer';

const Legal = loadable(() => import('legal/Legal'));

Legal.getInitialState = async ({state, params: {slug}}) => ({
    ...state,
    searchRequest: {
        ...searchRequestInitialState,
        pageType: Page.LEGAL,
    },
    page: await CMSUtils.getPageData({
        slug,
        customType: 'consumer-page-legal',
    }),
});

export default Legal;
